
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/agbs/agbs-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="agbs-view">
        <hero-section
            background-image="/images/hero/rechtliches-hero.png"
            headline="Allgemeine Geschäfts&shy;bedingungen"
            subheadline="Allgemeine Geschäfts&shy;bedingungen von FASE2"
            text="<strong>Hier finden sie unsere rechtlichen Angaben.</strong><br>Die rechtlichen Grundlagen für unsere Zusammenarbeit bei Dienstleistungen im Bereich der Grün- und Graupflege sowie Hausmeisterdienste."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="anwendungsbereich">
                <h2 id="anwendungsbereich">§ 1 Anwendungs&shy;bereich; Kollision</h2>
                <p>
                    <strong>(1)</strong> Diese allgemeinen Geschäftsbedingungen gelten für alle Verträge, die FASE2, Inhaber: Salvatore
                    Laudani und Hüseyin Sidar, Reinoldstr. 6b in 50676 Köln (im Folgenden: FASE2), mit Auftraggebern
                    über Dienstleistungen im Bereich der Grün- und Graupflege sowie Hausmeisterdienste abschließt.
                </p>
                <p>
                    <strong>(2)</strong> Der Einbeziehung entgegenstehender allgemeiner Geschäftsbedingungen von Auftraggebern oder
                    sonstigen Dritten wird hiermit ausdrücklich widersprochen.
                </p>
            </article>

            <article aria-labelledby="zustandekommen-vertraege">
                <h2 id="zustandekommen-vertraege">§ 2 Zustande&shy;kommen von Verträgen</h2>
                <p>
                    <strong>(1)</strong> Über das Kontaktformular auf der Webseite <a href="https://www.fase2.de">www.fase2.de</a> sowie über die Kontaktformulare der
                    einzelnen Reiter (z. B. „Grünpflege“, „Graupflege“) können Interessenten unverbindlich ein Angebot
                    anfordern. Die zur Unterbreitung eines Angebots notwendigen Mindestangaben (Name, Objektname,
                    Anschrift, Telefonnummer, E-Mail-Adresse, Art der Dienstleistung, Nachricht) sind hierbei
                    entsprechend unserer Datenschutzerklärung 
                    (<a href="/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">https://fase2.de/datenschutzerklaerung/</a>) zu machen.
                </p>
                <p>
                    <strong>(2)</strong> Auf die Anfrage nach Absatz 1 lässt FASE2 den Interessenten ein verbindliches Angebot zukommen,
                    welches alle wesentlichen Vertragsbestandteile enthält und auf diese allgemeinen
                    Geschäftsbedingungen, die <a href="/widerrufsbelehrung" target="_blank" rel="noopener noreferrer">Widerrufsbelehrung</a> sowie die
                    oben genannte <a href="/datenschutzerklaerung" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a> verweist. FASE2 ist nicht verpflichtet, Interessenten auf eine
                    Anfrage nach Absatz 1 ein verbindliches Angebot zu unterbreiten.
                </p>
                <p>
                    <strong>(3)</strong> Verträge kommen dadurch zustande, dass der Interessent das verbindliche Angebot nach Absatz 2
                    spätestens 28 Tage nach dessen Zugang verbindlich und ohne Vorbehalte annimmt. Für die
                    Fristwahrung kommt es auf den Zeitpunkt des Zugangs der Annahmeerklärung an.
                </p>
                <p>
                    <strong>(4)</strong> Hinsichtlich der Hauptleistungspflichten kommt der Vertrag mit dem Inhalt des Angebots nach
                    Absatz 2 zustande.
                </p>
            </article>

            <article aria-labelledby="pflichten-auftragnehmer">
                <h2 id="pflichten-auftragnehmer">§ 3 Allgemeine Pflichten des Auftragnehmers</h2>
                <p>
                    <strong>(1)</strong> Der Auftragnehmer verpflichtet sich, die nach diesem Vertrag zu erbringenden Leistungen, nach
                    den Grundlagen des Hausmeisterdienst-Handwerks und dem anerkannten Stand der Technik
                    durchzuführen.
                </p>
                <p>
                    <strong>(2)</strong> Die Übertragung von Dienstleistungen aus diesem Vertrag an Nachunternehmer bedarf nicht der
                    Zustimmung des Auftraggebers.
                </p>
                <p>
                    <strong>(3)</strong> Die im Leistungsverzeichnis festgelegten täglichen oder sonst turnusmäßigen Arbeiten sind
                    verbindliche Arbeitsnorm, d. h. sie sind ständig und gleichbleibend zu erbringen. Eine Änderung der
                    Dienstleistungsprogramme bedarf der Zustimmung beider Vertragsparteien. Dieser Absatz gilt nicht,
                    wenn die Dienstleistungen nur für einen bestimmten Tag in Auftrag gegeben wurden bzw. wenn es
                    sich um einmalige Arbeiten handelt.
                </p>
                <p>
                    <strong>(4)</strong> Der Auftragnehmer ist dafür verantwortlich, dass die Unfallverhütungsvorschriften der
                    Berufsgenossenschaft eingehalten werden.
                </p>
                <p>
                    <strong>(5)</strong> Die ausgehändigten Schlüssel (auch elektronische Zugangskarten etc.), sowie eventuell angefertigte
                    Duplikate sind nach Vertragsablauf ohne Vergütung dem Auftraggeber auszuhändigen.
                </p>
            </article>

            <article aria-labelledby="allgemeines">
                <h2 id="allgemeines">§ 4 Allgemeines</h2>
                <p>
                    <strong>(1)</strong> Die ggf. erforderlichen Umkleideräume für die Fachkräfte und die Abstellräume für Maschinen,
                    Geräte und Arbeitsmittel werden vom Auftraggeber unentgeltlich zur Verfügung gestellt. Der
                    Auftraggeber übernimmt keine Haftung für Schäden und Verluste an vom Auftragnehmer oder seinen
                    Arbeitskräften eingebrachten Sachen. Der Haftungsausschluss gilt nicht im Falle von Vorsatz und
                    grober Fahrlässigkeit des Auftragnehmers oder dessen Erfüllungsgehilfen.
                </p>
                <p>
                    <strong>(2)</strong> Das zur Auftragsausführung erforderliche Wasser und die elektrische Energie werden unentgeltlich
                    zur Verfügung gestellt. Auf einen sparsamen Verbrauch ist zu achten.
                </p>
            </article>

            <article aria-labelledby="art-umfang-leistung">
                <h2 id="art-umfang-leistung">§ 5 Art und Umfang der Leistung</h2>
                <p>
                    <strong>(1)</strong> Die Leistungen werden wie im Angebot nach § 2 Absatz 2 vereinbart ausgeführt. Änderungen und
                    Erweiterungen des Auftrags sind nur verbindlich, wenn sie nach Art und Umfang schriftlich von den
                    Parteien festgelegt werden.
                </p>
                <p>
                    <strong>(2)</strong> Nach § 9 Abs. 1 des Arbeitszeitgesetzes dürfen Arbeitnehmer an gesetzlichen Feiertagen nicht
                    beschäftigt werden. Eine Ausnahme nach § 10 Abs. 1 Satz 14 kommt – mit Ausnahme bestimmter
                    Branchen wie z. B. Gastronomie, Hotelgewerbe, Veranstaltungsgewerbe – nicht in Betracht. Sofern
                    nichts anderes ausdrücklich vertraglich vereinbart ist, werden unsererseits keine Arbeiten an
                    gesetzlichen Feiertagen und Sonntagen durchgeführt. Davon ausgenommen ist der Winterdienst
                    (Bereitschaftsdienst). Maßgeblich ist jeweils das Feiertagsgesetz des Bundeslandes, in dem die
                    Arbeiten durchgeführt werden sollen. Ist eine Durchführung an gesetzlichen Feiertagen oder
                    Sonntagen zwingend notwendig und seitens des Kunden ausdrücklich gewünscht (z. B. in den in Satz 1
                    genannten Branchen), so ist dies ausdrücklich vertraglich vereinbart. Der tarifvertragliche
                    Feiertagszuschlag ist bei Daueraufträgen bereits in der monatlichen Pauschale enthalten.
                </p>
                <p>
                    <strong>(3)</strong> (Nur für Daueraufträge) Fällt ein Feiertag auf einen Leistungstag, so ist eine Minderung der
                    monatlichen Pauschale nicht möglich. Ist eine Leistung an Feiertagen vereinbart, so ist dies schriftlich
                    vereinbart. Fällt eine Leistung auf einen gesetzlichen Feiertag, so werden an diesem Tag grundsätzlich
                    keine Arbeiten ausgeführt. Ein Anspruch auf anteilige Minderung der monatlichen Pauschale besteht
                    dadurch, insbesondere unter Hinweis auf das EntgFG (Entgeltfortzahlungsgesetz), Arbeitnehmer-
                    Entsendegesetz und Mindestlohngesetz, nicht. Soll eine Leistung wegen eines gesetzlichen Feiertags
                    vorgezogen oder nachgeholt werden, so wird diese Leistung zusätzlich in Höhe einer Tagespauschale
                    (monatliche Pauschale/Soll-Tage) vergütet. Die Angestellten des Auftragnehmers werden von diesem
                    entsprechend ebenfalls höher vergütet.
                </p>
                <p>
                    <strong>(4)</strong> Im Falle von Feiertagsarbeiten hat der Auftragnehmer das Recht, anderes als die in § 6 Absatz 5
                    genannten Mitarbeiter für die Leistung einzusetzen.
                </p>
                <p>
                    <strong>(5)</strong> Zwischen den Vertragsparteien besteht ein Vertragsverhältnis mit dem Inhalt nach § 2 Absatz 2 und
                    Absatz 3 für laufende oder einmalige Dienstleistungen im Bezug auf ein Objekt oder von Teilen hiervon.
                    Aufgrund dieses Verhältnisses ist der Auftragnehmer zur Erbringung der Dienstleistung verpflichtet.
                    Der Auftraggeber hat insoweit eine Mitwirkungspflicht, das Objekt durch geeignete Maßnahmen für
                    die Erbringung der Dienstleistung zur Verfügung zu stellen. Der Auftraggeber hat die Leistungen des
                    Auftragnehmers entsprechend der vertraglichen Vereinbarung zu vergüten.
                </p>
                <p>
                    <strong>(6)</strong> Kommt es ohne wichtigen Grund, der im Streitfall vom Auftraggeber zu beweisen ist, zu einer
                    Absage des Dienstleistungstermins, hat der Auftraggeber dem Auftragnehmer die vertraglich
                    vereinbarte Vergütung zu zahlen, ohne dass der Auftragnehmer zur Nachleistung verpflichtet ist.
                </p>
                <p>
                    <strong>(7)</strong> (Für Daueraufträge) Sofern zu einem bestimmten vereinbarten Termin keine regulären Arbeiten
                    notwendig sind, kann der Auftraggeber verlangen, dass stattdessen andere Arbeiten ausgeführt
                    werden, die im Leistungsumfang nicht enthalten sind und die durch die Arbeitskräfte nach § 6 Absatz 5
                    in der vertraglich vereinbarten Arbeitszeit umgesetzt werden können.
                </p>
            </article>

            <article aria-labelledby="dienstleistungspersonal-aufsichten">
                <h2 id="dienstleistungspersonal-aufsichten">§ 6 Dienstleistungs&shy;personal, Aufsichten</h2>
                <p>
                    <strong>(1)</strong> Der Auftragnehmer ist verpflichtet, sein Dienstleistungspersonal selbst oder durch fachkundige
                    Kontrollpersonen einzuweisen und regelmäßig zu beaufsichtigen.
                </p>
                <p>
                    <strong>(2)</strong> Der Auftragnehmer wird die ihm übertragenen Aufgaben nur durch geeignete Arbeitskräfte
                    ausführen lassen. Beanstandungen und Folgen aus einer Verletzung dieser Verpflichtung gehen zu
                    Lasten des Auftragnehmers.
                </p>
                <p>
                    <strong>(3)</strong> Personen, die vom Auftragnehmer nicht mit einer Dienstleistung in Bezug auf das Objekt beauftragt
                    sind, dürfen das Gebäude nicht betreten. In Schriftstücke, Akten und andere Unterlagen, die sich in
                    den Räumen befinden, darf keine Einsicht genommen werden; unbefugtes Öffnen von Schränken,
                    Schubladen und Ähnliches ist nicht erlaubt. Die unbefugte Benutzung von Telekommunikations- oder
                    Kopiergeräten des Auftraggebers ist nicht gestattet. Bei Zuwiderhandlungen kann der Auftraggeber
                    verlangen, dass die betreffende Arbeitskraft nicht mehr in seinem Einflussbereich eingesetzt wird.
                </p>
                <p>
                    <strong>(4)</strong> Die Arbeitskräfte sind zur Verschwiegenheit über dienstliche Vorgänge und Einrichtungen, die
                    ihnen bei ihrer Tätigkeit bekannt werden, arbeitsvertraglich zu verpflichten. Die Verpflichtung zur
                    Verschwiegenheit besteht auch nach Auflösung des Arbeitsvertrages weiter.
                </p>
                <p>
                    <strong>(5)</strong> Der Auftragnehmer hat dem Auftraggeber auf Verlangen eine Liste des im Gebäude eingesetzten
                    Personals zu übergeben.
                </p>
                <p>
                    <strong>(6)</strong> Schäden, die bei Verrichtung der Arbeiten durch den Auftragnehmer oder dessen Personal an
                    Einrichtungsgegenständen verursacht wurden, sind dem Auftraggeber unverzüglich mitzuteilen.
                </p>
                <p>
                    <strong>(7)</strong> Um eine ordnungsgemäße und einwandfreie Dienstleistung sicherzustellen, benennt der
                    Auftragnehmer eine/einen verantwortliche/-n Objektbeauftragte/-n, die/der mit dem Auftraggeber
                    oder dessen Beauftragten eng zusammenarbeitet. Die/der Objektbeauftragte (oder deren/dessen
                    Vertreter/-in) hat den Anweisungen und Wünschen des Auftraggebers oder dessen Beauftragten, die
                    sich auf die vertragsgemäße Dienstleistung beziehen, Folge zu leisten. Der Auftraggeber wird den
                    Auftragnehmer bei der Durchführung der vertraglichen Aufgaben angemessen unterstützen.
                </p>
            </article>

            <article aria-labelledby="betriebsmittel-arbeitsstoffe">
                <h2 id="betriebsmittel-arbeitsstoffe">§ 7 Betriebsmittel (Werkzeuge, Geräte, Maschinen) und Arbeitsstoffe (Behandlungsmittel)</h2>
                <p>
                    <strong>(1)</strong> Die zur Erbringung der Dienstleitung eingesetzten Betriebsmittel und Behandlungsmittel müssen
                    zur Erfüllung des Auftrags gemäß § 1 und im Hinblick auf Arbeitssicherheit, Umweltverträglichkeit und
                    Oberflächenschonung geeignet sein und fachkundig angewandt werden.
                </p>
                <p>
                    <strong>(2)</strong> Die von den Arbeitskräften eingesetzten Geräte müssen den Anforderungen der einschlägigen DIN-
                    Normen für Sicherheit, des Gerätesicherheitsgesetzes und den VDE-Vorschriften entsprechen.
                </p>
            </article>

            <article aria-labelledby="qualitaetssicherung">
                <h2 id="qualitaetssicherung">§ 8 Qualitäts&shy;sicherung</h2>
                <p>
                    <strong>(1)</strong> Die vollständige Erfüllung der Leistungspflichten nach § 1 wird durch ständige Eigenkontrolle des
                    Auftragnehmers erbracht
                    <br>1. durch regelmäßige Sichtkontrollen des Dienstleistungsergebnisses,
                    <br>2. durch Detailprüfungen mittels Prüflisten, die auf § 1 basieren und vom Auftragnehmer zu
                    erstellen sind und
                    <br>3. durch Nutzerbefragungen.
                </p>
                <p>
                    <strong>(2)</strong> Berechtigte Reklamationen, die vom Auftraggeber festgestellt werden und dem Auftragnehmer in
                    geeigneter Form übermittelt werden, müssen innerhalb von 24 Stunden beseitigt werden und die
                    ordnungsgemäße Beseitigung vom Auftraggeber schriftlich bestätigt werden.
                </p>
                <p>
                    <strong>(3)</strong> Der Auftraggeber hat das Recht, an den Detailprüfungen der Eigenkontrolle des Auftragnehmers
                    teilzunehmen. Ihm ist auf Verlangen Einsicht in die Prüflisten zu gewähren.
                </p>
            </article>

            <article aria-labelledby="haftung">
                <h2 id="haftung">§ 9 Haftung</h2>
                <p>
                    <strong>(1)</strong> Der Auftragnehmer haftet für Schäden, die nachweislich durch ihn oder seine Mitarbeiter bei der
                    Erfüllung der vertraglichen Aufgaben schuldhaft verursacht werden. Satz 1 gilt nur für Vorsatz oder
                    grobe Fahrlässigkeit des Auftragnehmers sowie seiner gesetzlichen Vertreter und Erfüllungsgehilfen,
                    es sei denn, dass die Rechtsgüter Leben, Gesundheit und körperliche Unversehrtheit oder vertragliche
                    Hauptpflichten betroffen sind, ohne welche die vertragliche Vereinbarung insgesamt ihren
                    wirtschaftlichen Sinn verlieren würde.
                </p>
                <p>
                    <strong>(2)</strong> Die ausreichende Berufshaftpflichtversicherung ist dem Auftraggeber von dem Auftragnehmer
                    nachzuweisen.
                </p>
            </article>

            <article aria-labelledby="abnahme-rechnung-maengelrechte">
                <h2 id="abnahme-rechnung-maengelrechte">§ 10 Abnahme, Rechnungsstellung, Mängelrechte</h2>
                <p>
                    <strong>(1)</strong> Die ordnungsgemäße Ausführung der geleisteten Arbeit ist bei Sonderdienstleistungen vom
                    Auftraggeber bzw. dessen Beauftragten jeweils danach schriftlich zu bescheinigen (Abnahme).
                    Turnusmäßige Arbeiten sind hiervon ausgenommen.
                </p>
                <p>
                    <strong>(2)</strong> Von einer ordnungsgemäßen Ausführung der Dienstleistungsarbeiten wird bis zu einem
                    berechtigten Widerspruch des Auftraggebers ausgegangen. Der Auftraggeber soll Mängel so früh wie
                    möglich, möglichst nach Vollendung der Arbeiten bzw. bei entsprechender Vereinbarung nach
                    Vollendung der Teilarbeiten, geltend machen. Er soll die Mängel dabei nach Art und Umfang so genau
                    wie möglich schriftlich bezeichnen. Verweigert der Auftraggeber die Abnahme ohne wichtigen Grund,
                    insbesondere ohne, dass ein Mangel gegeben ist, gilt die Abnahme dennoch als erfolgt.
                </p>
                <p>
                    <strong>(3)</strong> Der Auftragnehmer hat monatlich/nachträglich eine Rechnung in digitaler Ausfertigung (per E-Mail)
                    über die ausgeführten Arbeiten, unter Zugrundelegung der vereinbarten (Fest-)preise / der
                    vereinbarten Vergütung, einzureichen.
                </p>
                <p>
                    <strong>(4)</strong> Die vereinbarte Vergütung ist nach erfolgter Abnahme sofort zur Zahlung fällig, spätestens jedoch
                    mit Zugang der ordnungsgemäßen Rechnung beim Auftraggeber.
                </p>
                <p>
                    <strong>(5)</strong> Im Übrigen gelten für die Mängelgewährleistung die gesetzlichen Vorschriften. Die Vorschrift des §
                    9 Absatz 1 findet auf die Haftung für Mangel- und Mangelfolgeschäden des Auftragnehmers
                    entsprechende Anwendung.
                </p>
            </article>
            
            <article aria-labelledby="vertragsdauer-kuendigung">
                <h2 id="vertragsdauer-kuendigung">§ 11 Vertragsdauer und Kündigung</h2>
                <p>
                    <strong>(1)</strong> Verträge mit FASE2 kommen entweder auf bestimmte oder unbestimmte Zeit oder für einen ganz
                    bestimmten Termin und ganz bestimmte Dienstleistungen zustande.
                </p>
                <p>
                    <strong>(2)</strong> Sind Verträge auf unbestimmte Zeit geschlossen, können sie mit einer Frist von drei Monaten zum
                    Monatsende gekündigt werden.
                </p>
            </article>

            <article aria-labelledby="abtretung-aufrechnung-zurueckbehaltung">
                <h2 id="abtretung-aufrechnung-zurueckbehaltung">§ 12 Abtretungs- und Aufrechnungs&shy;verbot; Zurück&shy;behaltungs&shy;recht</h2>
                <p>
                    <strong>(1)</strong> Die Ansprüche des Auftraggebers aus diesem Vertrag sind nicht übertragbar.
                </p>
                <p>
                    <strong>(2)</strong> Der Auftraggeber darf gegen eine Vergütungsforderung des Auftragnehmers nur mit einer
                    unbestrittenen oder rechtskräftig festgestellten Gegenforderung aufrechnen.
                </p>
                <p>
                    <strong>(3)</strong> Ein Zurückbehaltungsrecht steht dem Auftraggeber in Bezug auf die Vergütungsforderung des
                    Auftragnehmers nicht zu, unbeschadet des Rechts, die Zahlung wegen Mängeln der Werkleistung
                    gemäß §§ 320, 322 BGB zu verweigern.
                </p>
            </article>

            <article aria-labelledby="widerrufsrecht">
                <h2 id="widerrufsrecht">§ 13 Widerrufsrecht</h2>
                <p>
                    <strong>(1)</strong> Dem Auftraggeber steht gemäß §§ 312g Abs. 1, 312c, 355 BGB ein Widerrufsrecht zu, sofern er
                    diesen Vertrag zu Zwecken abschließt, die überwiegend weder seiner gewerblichen noch
                    selbständigen beruflichen Tätigkeit zugerechnet werden können. Die Widerrufsfrist beträgt 14 Tage
                    ab Vertragsschluss. Für die Rechtzeitigkeit des Widerrufs reicht dessen fristgerechte Abgabe. Der
                    Widerruf ist an keine Form gebunden und bedarf keiner Begründung.
                </p>
                <p>
                    <strong>(2)</strong> Der Auftraggeber erklärt sich im Falle des Absatzes 1 Satz 1 damit einverstanden, dass der
                    Auftragnehmer bereits vor Ablauf der Widerrufsfrist mit der Ausführung der Arbeiten beginnt. Der
                    Auftraggeber nimmt zur Kenntnis, dass das Widerrufsrecht in diesem Fall mit der vollständigen
                    Vertragserfüllung seitens des Auftragnehmers erlischt.
                </p>
                <p>
                    <strong>(3)</strong> Widerruft der Auftraggeber im Falle des Absatzes 2 diesen Vertrag zwischen dem Beginn der
                    Arbeiten und deren Beendigung, so hat der Auftraggeber dem Auftragnehmer seine bis dahin
                    erbrachten Leistungen anteilig zu vergüten.
                </p>
            </article>

            <article aria-labelledby="schlussbestimmungen">
                <h2 id="schlussbestimmungen">§ 14 Schluss&shy;bestimmungen</h2>
                <p>
                    <strong>(1)</strong> Nebenabreden zu diesem Vertrag bestehen nicht. Die Änderung, Aufhebung oder Ergänzung dieses
                    Vertrags bedürfen zu ihrer Wirksamkeit der Schriftform. Dasselbe gilt für die Vorschrift des Satzes 2.
                </p>
                <p>
                    <strong>(2)</strong> Sollten einzelne Bestimmungen dieses Vertrags unwirksam sein, so bleibt die Wirksamkeit des
                    Vertrags im Übrigen unberührt. In diesem Fall soll an die Stelle der unwirksamen Bestimmung eine
                    solche wirksame treten, die den wirtschaftlichen Interessen der Parteien am nächsten kommt.
                </p>
                <p>
                    <strong>(3)</strong> Auf diesen Vertrag findet ausschließlich deutsches Recht unter Ausschluss des UN-Kaufrechts
                    Anwendung.
                </p>
                <p>
                    <strong>(4)</strong> Unbeschadet zwingender gesetzlicher Vorschriften ist Gerichtsstand für alle aus diesem Vertrag
                    resultierenden Streitigkeiten Köln. Satz 1 gilt nur, wenn beide Vertragsparteien Vollkaufleute im Sinne
                    des Handelsgesetzbuchs sind.
                </p>
            </article>
        </div>
    </section>`,
      style: `agbs-view .agbs-view {
  margin: 0;
  padding: 0;
}
agbs-view .agbs-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
agbs-view .agbs-view .wrapper article {
  margin: 0 0 32px 0;
  padding: 0;
}
agbs-view .agbs-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  agbs-view .agbs-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    events: [
        ['click', '.widerrufsbelehrung-view a[href^="/"]:not([target])', function (event) {
                event.preventDefault();
                if (this.buttonLink2)
                    router.navigate(this.buttonLink2);
            }],
    ]
};
 })()`
    };
  